<template>
  <div class="policy-content">
    <div class="policy-view">
      <div class="bannerView">
        <img src="../../../assets/policy/banner.webp" />
      </div>
      <div class="routerView">
        <router-view :key="key" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "policy",
  computed: {
    key() {
      return this.$route.path;
    }
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped>
@import "~@/styles/variables.less";
.bannerView {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
  img {
    display: block;
    width: 100%;
  }
}
.policy-view {
  width: 100%;
  & .routerView {
    width: @contentWidth;
    margin: 0 auto;
  }
  .routerLink {
    height: 50px;
    background: rgba(33, 49, 124, 1);
    margin-bottom: 20px;
  }
}
.router-slider {
  width: @contentWidth;
  margin: 0 auto;
  display: flex;
  padding: 0 20px;
  a {
    text-align: center;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    color: #ffff;
    margin-right: 8px;
    &.router-link-active {
      background: rgba(240, 144, 46, 1);
    }
  }
}
</style>
